import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/common/ProtectedRoute';

import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import EmployeeDashboard from './pages/employee/EmployeeDashboard';
import OnboardingWizard from './pages/employee/OnboardingWizard';
import CompanyPolicies from './pages/employee/CompanyPolicies';
import PolicyChat from './pages/employee/PolicyChat';
import MyProjects from './pages/employee/MyProjects';
import ProjectDetails from './pages/employee/ProjectDetails';
import Profile from './pages/employee/Profile';

import AdminDashboard from './pages/admin/AdminDashboard';
import AdminHR from './pages/admin/AdminHR';
import AdminEmployees from './pages/admin/AdminEmployees';
import AdminDepartments from './pages/admin/AdminDepartments';
import AdminProjects from './pages/admin/AdminProjects';
import AdminPolicies from './pages/admin/AdminPolicies';
import AdminQuestions from './pages/admin/AdminQuestions';
import AdminAssignments from './pages/admin/AdminAssignments';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />

            {/* Protected Employee Routes */}
            <Route element={<ProtectedRoute adminOnly={false} />}>
              <Route path="/dashboard" element={<EmployeeDashboard />} />
              <Route path="/onboarding" element={<OnboardingWizard />} />
              <Route path="/company-policies" element={<CompanyPolicies />} />
              <Route path="/company-policies/chat" element={<PolicyChat />} />
              <Route path="/my-projects" element={<MyProjects />} />
              <Route path="/my-projects/:id" element={<ProjectDetails />} />
              <Route path="/profile" element={<Profile />} />
            </Route>

            {/* Protected Super Admin Routes */}
            <Route element={<ProtectedRoute adminOnly={true} />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/hr" element={<AdminHR />} />
              <Route path="/admin/employees" element={<AdminEmployees />} />
              <Route path="/admin/departments" element={<AdminDepartments />} />
              <Route path="/admin/projects" element={<AdminProjects />} />
              <Route path="/admin/policies" element={<AdminPolicies />} />
              <Route path="/admin/questions" element={<AdminQuestions />} />
              <Route path="/admin/assignments" element={<AdminAssignments />} />
            </Route>

            {/* Default Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}


export default App;
